import { Heading, Secondary, Text } from '@cinch-labs/design-system'
import { StoryblokImage, storyblokEditable } from '@cinch-nx/data-storyblok'
import {
  Carousel,
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
} from '@cinch-nx/shared-ui'
import { useMediaQuery } from '@react-hook/media-query'

import type { Partnerships as AboutUsPartnershipsProps } from '../../types/about-us-page'
import styles from './partnerships.module.css'

export const Partnerships: React.FC<AboutUsPartnershipsProps> = (blok) => {
  const { heading, body, partners } = blok
  const [CTA] = blok.CTA || []
  const isDesktop = useMediaQuery('(min-width: 1024px)')

  const carouselSettings = {
    name: 'about-us-partnerships',
    ariaLabels: {
      previous: 'Go to previous slide',
      next: 'Go to next slide',
    },
    swiperSettings: {
      spaceBetween: 78,
      slidesPerView: isDesktop ? 3 : 1,
    },
  }

  return (
    <div {...storyblokEditable(blok)}>
      <Heading className={styles.heading}>{heading}</Heading>
      <Text className={styles.body}>{body}</Text>

      <Carousel
        name={carouselSettings.name}
        swiperSettings={carouselSettings.swiperSettings}
        customClassNames={{
          carousel: styles.carousel,
        }}
      >
        {partners
          ?.filter((image: StoryblokImage) => image?.filename)
          ?.map((image: StoryblokImage) => (
            <CarouselSlide key={image.id}>
              <div className={styles.imageWrapper}>
                <img
                  src={image.filename}
                  alt={image.alt ?? undefined}
                  className={styles.image}
                />
              </div>
            </CarouselSlide>
          ))}
      </Carousel>
      <CarouselControls customClassNames={styles.carouselControls}>
        <CarouselPagination name={carouselSettings.name} />
        <CarouselNavigation
          name={carouselSettings.name}
          ariaLabels={carouselSettings.ariaLabels}
          customClassNames={{
            prevButton: styles.carouselNavButton,
            nextButton: styles.carouselNavButton,
          }}
        />
      </CarouselControls>

      {CTA ? (
        <div {...storyblokEditable(CTA)}>
          <div className={styles.buttonWrapper}>
            <Secondary
              element="a"
              href={CTA.url}
              classNames={{ button: styles.button }}
            >
              {CTA.text}
            </Secondary>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default Partnerships
